"use strict"
import { IPopupProps } from "@/app/types/types"
import CloseIcon from "../icons/CloseIcon"
import { useEffect, useRef } from "react"
import { handleWheel } from "@/app/utils/helperFunctions"

const Popup = ({
	customClassWrapper,
	setIsOpen,
	isOpen,
	children,
	construction = false,
	noScroll,
	onClose
}: IPopupProps) => {
	const containerRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (isOpen) {
			window.lenis?.stopScroll?.();
		} else {
			window.lenis?.startScroll?.();
		}

		containerRef.current?.addEventListener('wheel', handleWheel, { passive: false });
		return () => {
			if (isOpen) {
				window.lenis?.startScroll?.(true);
			}
			containerRef.current?.removeEventListener('wheel', handleWheel);
		}
	}, [isOpen, setIsOpen])

	if (!isOpen) return null

	return (
		<div
			ref={containerRef}
			className={`popup ${customClassWrapper} fixed top-0 left-0 right-0 z-[9999] bottom-0 w-screen h-screen flex justify-center overflow-hidden opacity-1 items-center ${isOpen ? "opacity-1" : "opacity-0 pointer-events-none"
				} transition-opacity duration-300`}
		>
			<div className={`popup_content ${construction && "!h-auto"}`}>
				<div
					className="popup_close absolute top-4 right-5 p-4 cursor-pointer z-[55] "
					onClick={() => {
						setIsOpen(false);
						if (onClose) {
							onClose();
						}
					}}
				>
					<CloseIcon color="#fff" />
				</div>
				<div className={`popup_body ${noScroll ? "" : "h-[90vh]"}  lg:h-[100%] ${noScroll ? "overflow-hidden" : "overflow-auto"} `}>
					{children}
				</div>
			</div>
		</div>
	)
}

export default Popup
